import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {useTranslation} from "react-i18next";


Chart.register(...registerables);

const ChartBar = ({ labels = [], data = [], title = '' }) => {
  const { t } = useTranslation();

  const hasData =
    Array.isArray(labels) && labels.length > 0 &&
    Array.isArray(data) && data.length > 0 &&
    data.some(ds => Array.isArray(ds.data) && ds.data.some(v => v > 0));

  const options = {
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
    layout: {
      padding: {
        top: 30,
        bottom: 20,
      },
    },
    plugins: {
      datalabels: {
        display: (context) => {
          const value = context.dataset.data[context.dataIndex];
          const maxY = context.chart.scales['y'].max;
          return value > 0 && value > maxY * 0.03;
        },
        color: 'white',
        anchor: 'center',
        align: 'center',
        offset: 0,
        formatter: (value) => `${value}`,
      },
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 10,
          usePointStyle: true,
        },
      },
    },
  };

  return (
    <div style={{ minHeight: '400px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <h5>{title}</h5>
      {hasData ? (
        <Bar
          height="100vh"
          data={{ labels, datasets: data }}
          options={options}
          plugins={[ChartDataLabels]}
        />
      ) : (
        <p style={{ color: '#888', fontStyle: 'italic' }}>{t("Reports.Dashboard.RankingTable.NoData")}</p>
      )}
    </div>
  );
};

export default ChartBar;
